import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { I18nModule } from '@recruitee/i18n';

import { RtUICoreOverlayModule } from '../../core/overlay/overlay.module';
import { ButtonNewModule } from '../button-new/button-new.module';
import { ButtonModule } from '../button/button.module';
import { DropdownModule } from '../dropdown/dropdown.module';
import { IconModule } from '../icon/icon.module';
import { ResultsLimitButtonComponent } from './results-limit-button.component';

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    ButtonModule,
    ButtonNewModule,
    IconModule,
    RtUICoreOverlayModule,
    DropdownModule,
  ],
  declarations: [ResultsLimitButtonComponent],
  exports: [ResultsLimitButtonComponent],
})
export class ResultsLimitButtonModule {}

export { ResultsLimitButtonComponent };
